import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Row, Col, Button, Icon, Upload, Modal, Select, message, Form, Spin, Tooltip } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import injectSheet from 'react-jss';
import { tokens } from 'src/design-system';
import { commonStyles } from 'src/Library/CommonStyles';
import { Document } from './Interfaces/Shipment.interface';
import { getFileExtension } from 'src/utils/utils';
import { fileUploadOnS3 } from 'src/api/inquiry';
import { uploadImageToS3 } from 'src/api/salesorder';
import { updateDocuments } from 'src/api/shipmentTracking';
import { RouterProps , StylesProps } from 'src/Library/Types';
import { useGenericState } from 'src/Library/UseGenericState';
import { formRules } from 'src/Library/Helper';

const styles = theme => ({
    ...commonStyles(theme),
      docStyle: {
        fontWeight: tokens.fontWeight.semibold,
        fontSize: tokens.fontSize.h3,
        lineHeight: '18px',
    },
      imgDiv : {
        borderRight: `1px solid ${tokens.colors.border}`,
        margin: '3% 0 10% 0',
        display: 'flex',
        height: '65px',
        alignItems: 'center',
      },
      img : {
        width: '80%',
      },
      titleCol : {
          fontSize: tokens.fontSize.h3,
          lineHeight: '22px',
          fontWeight: tokens.fontWeight.semibold,
      },
      labelStyle: {
          fontSize: tokens.fontSize.small,
          lineHeight: '14px',
      },
      inputBar: {
          width: '97%',
      },
      buttonStyle: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
      },
      flexRow: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: '10px',
      },
      docRow: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '98%'
      },
      uploadButton: {
        borderRadius: tokens.radius.md,
        textShadow: 'none',
    },
    typeStyle: {
      fontWeight: tokens.fontWeight.semibold,
      fontSize: tokens.fontSize.body,
    },
    tableBorder: {
      border: `1px solid ${tokens.colors.border}`,
      marginRight: '2%',
      marginTop: '2%'
    },
  });
interface IProps extends
  ReduxProps,
  RouterProps,
  FormComponentProps,
  StylesProps<ReturnType<typeof styles>>{
    documents: Document[];
    visible: boolean,
    isArchived: boolean,
    setUploadModalVisible: (isUploadModalVisible: boolean) => any,
    setLoader: (loading: boolean) => any,
    handleReloadClick: () => any;
}
interface StateProps {
    uploading?: boolean;
    newFile?: Document;
    type?: string;
}
interface ReduxProps {
    documentTypes: Object;
}
const DocumentUploadModal = (props: IProps) => {
    const [state, setState] = useGenericState<StateProps>({
        uploading: false,
    });
    const {
      classes,
      documents,
      documentTypes,
      form,
      visible,
      isArchived,
      setUploadModalVisible,
      setLoader,
      handleReloadClick,
    } = props;
    const { newFile, uploading } = state;
    const s3LinkRequest = async ({ file }) => {
        setState({
          uploading: true,
        });
        const extension = getFileExtension(file.name);
        const response = await fileUploadOnS3({
          extension,
          fileName: file.name,
          document_type: file.type,
          initialPath: 'shipment',
        });
    
        if (response.isSuccess) {
          const upload = await uploadImageToS3(file, response.data.post, extension);
          if (upload.isSuccess) {
            const addedAt = Date.now().valueOf();
            setState({
              ...state.newFile,
              newFile: {
                type: state.type,
                name: file.name,
                url: response.data.get,
                addedAt: addedAt,
              },
              uploading: false,
            });
          }
        } else {
          message.error(response.errorMessage);
          setState({
            uploading: false,
          });
        }
    };
    const handleUpload = () => {
        form.validateFields((err, val) => {
          if (err) return;
          if (!newFile?.url) {
            message.error('Please Upload the Document');
            return;
          }
          uploadDocument();
        });
      };
    
      const uploadDocument = async () => {
        const { id } = props.match.params;
        const docs = [newFile];
        const body = {
          shipmentId: id,
          documents: [
            ...documents,
            ...docs,
          ],
        }
        setLoader(true);
        const response = await updateDocuments(body);
        setLoader(false);
        if (!response.isSuccess) {
          message.error(response.errorMessage);
        } else {
          form.resetFields();
          handleReloadClick();
        }
    };
    const renderDocumentType = () => {
        return <Row>
          <Col span={8}
            className={classes.typeStyle}>
            Type*
          </Col>
          <Col span={16}>
            <Form.Item>
              {form.getFieldDecorator('type',{
                rules: [formRules.required],
              })(<Select
              dropdownMatchSelectWidth={false}
              optionLabelProp="data-value"
              disabled={state.uploading}
              placeholder="Select Document Type"
              onChange={(type?: string) => {
                setState({
                  newFile: {
                    ...newFile,
                    type,
                  },
                  type,
                });
              }}
              style={{ width: 200 }}>
              {Object.keys(documentTypes).map((item) => <Select.Option
                key={item}
                data-value={documentTypes[item]}>
                {documentTypes[item]}
                </Select.Option>)}
              </Select>)}
            </Form.Item>
          </Col>
        </Row>;
    };
    const renderUploadButton = () => {
        return <Row>
          <Col span={8}></Col>
          <Col span={16}>
            <Upload style={{ width: '80%' }}
              showUploadList={false}
              multiple={false}
              disabled={uploading}
              customRequest={(file: any) => s3LinkRequest(file)}
              >
              <Button
                disabled={uploading || isArchived}
              >
                <Icon type="upload" /> Browse
              </Button>
            </Upload>
          </Col>
        </Row>;
      };
      const renderDocument = () => {
        const { uploading, newFile } = state;
        if (uploading) {
          return <Spin
            size="small"
            style={{
              width: '20%',
              maxWidth: '20%',
            }}
          />;
        };
      
        return <Tooltip
          placement="leftTop"
          title={newFile?.name || '-'}
          className={classes.ellipses}
        >
          <span
            style={{
              width: '20%',
              maxWidth: '20%',
            }}
          >
            <a
              href={newFile?.url}
            >
              {newFile?.name || ''}
            </a>
          </span>
        </Tooltip>;
      };
    
      const renderRemoveUpload = () => {
        const { newFile } = state;
        if (newFile?.name && newFile.url) {
          return <Tooltip
            title="Remove Document"
          >
            <Icon
              type="close-circle"
              style={{ marginLeft: 10 }}
              onClick={() => setState({ newFile: undefined })}
            />
          </Tooltip>
        };
        return null;
      };
      const renderDocumentAndRemove = () => {
        return <Row
          style={{ marginTop: '2%' }}>
          <Col span={8}></Col>
          <Col span={10}
          className={classes.ellipses}>
          {renderDocument()}
          </Col>
          <Col span={2}>
            {renderRemoveUpload()}
          </Col>
        </Row>;
      };
      const renderUploadModal = () => {
        return <Modal
          visible={visible}
          okText="Upload"
          confirmLoading={state.uploading}
          onOk={() => handleUpload()}
          onCancel={() => {
            setState({ newFile: undefined });
            setUploadModalVisible(false);
            form.resetFields();
          }}
          title="Upload Document">
          <Form>
            {renderDocumentType()}
            {renderUploadButton()}
            {renderDocumentAndRemove()}
          </Form>
        </Modal>;
      };
      return renderUploadModal();
}
const mapStateToProps = ({ masterData }, ownProps) => {
    const { allowedDocumentTypes } = masterData?.execution || {};
    return {
      documentTypes: allowedDocumentTypes,
    };
  };
const DocumentUploadModalStyled = injectSheet(styles)(DocumentUploadModal);
const DocumentUploadModalForm = Form.create()(DocumentUploadModalStyled);
export default React.memo(withRouter(connect(mapStateToProps)(DocumentUploadModalForm)));